<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedQualificationType"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Qualificação Lead
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedQualificationType: this.value,
      options: [
        { value: '0', text: 'Qualificado' },
        { value: '1', text: 'Sem UC / Encerrada' },
        { value: '2', text: 'MT' },
        { value: '3', text: 'Consumo baixo' },
        { value: '4', text: 'SCEE S/ICMS com saldo' },
        { value: '5', text: 'SCEE isenta com saldo' },
        { value: '6', text: 'Irrigante noturno' },
        { value: '7', text: 'Sem histórico de contas' },
      ],
    };
  },
  watch: {
    value(newVal) {
      this.selectedQualificationType = newVal;
    },
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedQualificationType);
    },
  },
};
</script>
